import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GridFilterModel } from "@mui/x-data-grid-pro";
import { useState } from "react";
import { FilterModeSwitch } from "./components/FilterModeSwitch";
import { MaintenanceFilters } from "./components/MaintenanceFilters";
import { MaintenanceGrid } from "./components/MaintenanceGrid";
import { QuickFilters } from "./components/QuickFilters";
import { useMaintenanceData } from "./hooks/useMaintenanceData";
import { mapLazy } from "@/utilities/mapLazy";

const FilterStackLayout = mapLazy(
  "FilterStackLayout",
  import("@/components/layout/FilterStackLayout"),
);

export default function MaintenancePage() {
  // Needed here, beacause we have the Filter Cards, and filterModel is not available via apiRef
  const [filterModel, setFilterModel] = useState<GridFilterModel>({ items: [] });

  const { data } = useMaintenanceData();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));
  const [mode, setMode] = useState<"quick" | "advanced">("quick");

  return (
    <FilterStackLayout
      isMobile={isMobile}
      minHeight={60}
      filters={
        <>
          <FilterModeSwitch mode={mode} onChange={setMode} />
          {mode === "quick" ? (
            <QuickFilters filterModel={filterModel} setFilterModel={setFilterModel} />
          ) : (
            <MaintenanceFilters filterModel={filterModel} setFilterModel={setFilterModel} />
          )}
        </>
      }
      content={
        <MaintenanceGrid data={data} filterModel={filterModel} setFilterModel={setFilterModel} />
      }
    />
  );
}
